<style lang="less">
#timeTable {
  min-width: 1000px;
  // overflow: scroll;
}
#room_timeLine {
  .ivu-row {
    height: 50px;
  }
  .ivu-col {
    height: 50px;
    border: 1px solid #f1f1f1;
    background: white;
    text-align: center;
    line-height: 50px;
    // width: 125px;
  }
}
#room_roomList {
  .ivu-row {
    height: 80px;
  }
  .ivu-col {
    height: 80px;
    border: 1px solid #f1f1f1;
    background: white;
    text-align: center;
    // width: 125px;
  }
  .room_div {
    line-height: 80px;
  }
  .table_div {
    text-align: left;
    cursor: pointer;
  }
  .table_div:hover {
    background: #f1f1f1;
  }
  .table_div button {
    margin-top: 5px !important;
  }
}
#roomView,
#roomView2 {
  .ivu-col {
    line-height: 32px;
  }
  .ivu-row {
    margin-bottom: 15px;
  }
  .ivu-input[disabled],
  fieldset[disabled] .ivu-input {
    color: #000 !important;
  }
}
</style>
<template>
	<div>
		<div id="workItem">
			<Card style="min-width:1000px" v-if="projectData.id != 0">
				<Row>
					<Col span="16"> 项目名称:{{projectData.projectName}}
					</Col>
					<Col span="8" v-if="backable">
					<Button type="primary" @click="backProjectList" style="float:right">
						<span> 返回项目列表 </span>
						<Icon type="chevron-right"></Icon>
					</Button>
					</Col>
				</Row>
				<Row>
					<Col span="6"> 项目编号:{{projectData.projectFull}}
					</Col>
				</Row>
				<template v-for="(item,key) in thisNpData">
					<Row style="margin-top: 10px;color: #2d8cf0;">
						<Col span="2">
						<!-- <template v-if="item.rate == 0">
							(无效)
						</template> -->
						{{item.roomName}}</Col>
						<Col span="1"> {{item.filiale}}
						</Col>
						<Col span="8">{{item.beginTime|filterTime3}}&nbsp;~&nbsp;{{item.endTime|filterTime3}}</Col>
						<Col span="8">
						<Button type="primary" size="small" @click="showDetailModal(item)" style="margin-right:15px;">详情/修改</Button>
						<Button type="error" size="small" @click="delete_book(item, 'project')">删除</Button>
						<!-- <template v-if="item.creator == formObj.creator && item.rate == 1">
							<Button type="error" size="small" @click="doValid(item,0)" style="margin-left:10px">置无效</Button>
						</template>
						<template v-else-if="item.creator == formObj.creator && item.rate == 0">
							<Button type="success" size="small" @click="doValid(item,1)" style="margin-left:10px">置有效</Button>
						</template> -->
						</Col>
					</Row>
				</template>
				<div style="margin:5px 0;">
					<Form inline>
						<FormItem label="专家数量（指从专家库中抽取的）" :label-width="200">
							<Input style="width:80px;" v-model="projectForm.expertNum"></Input>
						</FormItem>
						<FormItem label="采购人代表数量" :label-width="120">
							<Input style="width:80px;" v-model="projectForm.purchaserNum"></Input>
						</FormItem>
						<FormItem label="投标人数" :label-width="80">
							<Input style="width:80px;margin-right:15px;" v-model="projectForm.bidderNum"></Input>
							<Button type="primary" size="small" @click="confirmProjectForm">确定</Button>
						</FormItem>
					</Form>
				</div>
			</Card>
			<Card style="min-width:1000px" v-if="argumentData.id != 0">
				<Row>
					<Col span="16"> 论证名称:{{argumentData.argumentName}}
					</Col>
					<Col span="8" v-if="backable">
					<Button type="primary" @click="backProjectList" style="float:right">
						<span> 返回项目列表 </span>
						<Icon type="chevron-right"></Icon>
					</Button>
					</Col>
				</Row>
				<Row>
					<Col span="6"> 项目编号:{{argumentData.argumentFull}}
					</Col>
				</Row>
				<Row style="margin-top: 10px;color: #2d8cf0;" v-if="thisAGDate.clMeetingRoomExt.id!=0">
					<Col span="2">{{thisAGDate.clMeetingRoomExt.roomName}}</Col>
					<Col span="1"> {{thisAGDate.clMeetingRoomExt.site}}</Col>
					<Col span="8">{{thisAGDate.clMeetingRoomExt.beginTime|filterTime3}}&nbsp;~&nbsp;{{thisAGDate.clMeetingRoomExt.endTime|filterTime3}}</Col>
					<Col span="8">
						<Button type="primary" size="small" @click="showDetailModal(thisAGDate)" style="margin-right:15px;">详情/修改</Button>
						<Button type="error" size="small" @click="delete_book(thisAGDate)" v-if="new Date()<new Date(thisAGDate.clMeetingRoomExt.endTime)">删除</Button>
					</Col>
				</Row>
			</Card>
			<Card style="min-width:1000px">
				<Row>
					<Col span="3">
					<Select v-model="thisCity" style="width:120px">
						<Option v-for="item in cityList" :value="item.name" :key="item.ID">{{ item.name }}</Option>
					</Select>
					</Col>
					<Col span="6"> &nbsp;&nbsp;
					<DatePicker type="date" v-model="selectDate" placeholder="Select date" style="width: 200px"></DatePicker>
					</Col>
					<Col span="9">
					<Button type="primary" @click="getData">刷新当前数据</Button>
					<div v-if="projectData == null">

					</div>
					</Col>
				</Row>
			</Card>
		</div>
		<div id="timeTable">
			<div id="room_timeLine">
				<Row>
					<Col span="3">
					</Col>
					<Col span="3" v-for="(item,key) in dateRate"> {{item.weekDay}}({{item.totalDate|filterTime2}})
					</Col>
				</Row>
			</div>
			<div id="room_roomList">
				<Row v-for="(roomItem,roomKey) in roomList">
					<Col span="3" class="room_div"> {{roomItem.会议室名称}}
					</Col>
					<template v-for="(dataItem,datakey,dataindex) in dataTable[roomItem.会议室名称]">
						<Col span="3" @click.native="showRoomModal(roomKey,datakey,dataindex)" class="table_div">
						<template v-for="(item,key,index) in dataItem">
							<template v-if="item.clProjectDb !=null && item.projectId != projectData.id">
								<Button size="small" type="primary" style="width:90%;float:left;overflow:hidden;margin:0 5%" :title="item.clProjectDb.projectName">
									{{item.beginTime|filterTime}}&nbsp;&nbsp;&nbsp;{{item.clProjectDb.projectName}}
								</Button>
							</template>
							<template v-else-if="(item.clProjectDb !=null && item.projectId == projectData.id)||(argumentData.id!=0&&item.clMeetingRoomExtId==thisAGDate.clMeetingRoomExt.id)">
								<Button size="small" type="error" style="width:90%;float:left;overflow:hidden;margin:0 5%" :title="argumentData.id==0? item.clProjectDb.projectName : item.clMeetingRoomExt.title">
									{{item.beginTime|filterTime}}&nbsp;&nbsp;&nbsp;{{argumentData.id==0?item.clProjectDb.projectName:item.clMeetingRoomExt.title}}
								</Button>
							</template>
							<template v-else>
								<Button size="small" style="width:90%;float:left;overflow:hidden;margin:0 5%" :title="item.clMeetingRoomExt.title">
									{{item.beginTime|filterTime}}&nbsp;&nbsp;&nbsp;{{item.clMeetingRoomExt.title}}
								</Button>
							</template>
						</template>
						</Col>
					</template>
				</Row>
			</div>
		</div>
		<Modal v-model="roomBookModal" title="具体预约时间表" width="800px" :mask-closable="false" id="roomView" :styles="{top: '20px'}">
			<div style="padding-bottom:5px;color:#ff9900;">因通知提醒功能正常使用，规范填写人员信息，相关人员填写请点击添加/修改按钮</div>
			<Row>
				<Col span="3">{{thisCity}}</Col>
				<Col span="10">
				<!-- {{thisClickRoom.会议室名称}} -->
				<Select multiple="multiple" v-model="multi_room" style="width:300px" :disabled="!(ifBook == true)">
					<Option v-for="item in roomList" :value="item['会议室名称']">{{item['会议室名称']}}</Option>
				</Select>
				
				</Col>
				<Col span="8">{{thisClickDay|formatDate}}</Col>
			</Row>
			<div v-show="replenishRoom ? true : ifBook">
				<!--预约时显示-->
				<Form id="basic" v-if="projectData.id == 0">
					<Row>
						<Col span="3"> 会议类别:
						</Col>
						<Col span="5">
						<Select v-model="formObj.type" style="width:120px">
							<Option v-for="(item,index) in  typeList" :key="index" :value="item">{{item}}</Option>
						</Select>
						</Col>
						<Col span="3" v-if="formObj.type=='论证'"> 论证时间:
						</Col>
						<Col span="9" v-if="formObj.type=='论证'">
						<DatePicker type="datetime" v-model="formObj.argumentTime" format="yyyy-MM-dd HH:mm" placeholder="Select date and time" style="width: 180px"></DatePicker>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 部门/分公司:
						</Col>
						<Col span="5">
						<!-- <Input v-model="formObj.site" style="width:120px"></Input> -->
						<Select v-model="formObj.site" style="width:120px">
							<Option
								v-for="area in areaArr"
								:key="area.id"
								:value="area.name"
							>{{area.name}}</Option>
						</Select>
						</Col>
						<Col span="2"> 主持人:
						</Col>
						<Col span="6">
						<Input v-model="formObj.compere" style="width:100px" readonly></Input>
						<Button type="primary" size="small" style="margin: 0 5px;" @click="addUserModal('compere')">添加/修改</Button>
						</Col>
						<Col span="2"> 专家数量:
						</Col>
						<Col span="4">
						<Input v-model="formObj.expertNum" style="width:120px;margin-left:5px"></Input>
						</Col>
					</Row>
					</Row>
					<Row>
						<Col span="3"> 会议时间:
						</Col>
						<Col span="21">
						<DatePicker type="datetime" v-model="formObj.start" format="yyyy-MM-dd HH:mm" placeholder="Select date and time" style="width: 200px"></DatePicker>
						&nbsp;~&nbsp;
						<DatePicker type="datetime" v-model="formObj.end" format="yyyy-MM-dd HH:mm" placeholder="Select date and time" style="width: 200px"></DatePicker>
						会议时间约为:{{timeDifference}} 小时
						</Col>
					</Row>
					<Row>
						<Col span="3"> 会议名称:
						</Col>
						<Col span="21">
						<Input v-model="formObj.title"></Input>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 备注:
						</Col>
						<Col span="21">
						<Input type="textarea" v-model="formObj.content"></Input>
						</Col>
					</Row>
					<Row v-if="formObj.type=='论证'">
						<Row>
							<Col span="3"> 采购单位名称:
							</Col>
							<Col span="21">
							<Input v-model="formObj.purchaser"></Input>
							</Col>
						</Row>
						<Row>
							<Col span="3"> 联系人:
							</Col>
							<Col span="5">
							<Input v-model="formObj.contacts" style="width:120px"></Input>
							</Col>
							<Col span="3"> 联系电话:
							</Col>
							<Col span="5">
							<Input v-model="formObj.tel" style="width:120px"></Input>
							</Col>
							<Col span="3"> 项目名称:
							</Col>
							<Col span="5">
							<Input v-model="formObj.projectName" style="width:120px"></Input>
							</Col>
						</Row>
						<Row>
							<Col span="4"> 采购人代表人数:
							</Col>
							<Col span="3">
							<Input v-model="formObj.purchaserNum" style="width:50px"></Input>
							</Col>
							<Col span="4"> 是否有申请理由:
							</Col>
							<Col span="3">
							<Select style="width:70px" v-model="formObj.isReason">
								<Option value="是">是</Option>
								<Option value="否">否</Option>
							</Select>
							</Col>
							<Col span="4"> 是否有用户需求:
							</Col>
							<Col span="3">
							<Select style="width:70px" v-model="formObj.isNeed">
								<Option value="是">是</Option>
								<Option value="否">否</Option>
							</Select>
							</Col>
						</Row>
						<Row>
							<Col span="3"> 需求品目1:
							</Col>
							<Col span="5">
							<Input v-model="formObj.item1" style="width:120px"></Input>
							</Col>
							<Col span="3"> 需求品目2:
							</Col>
							<Col span="5">
							<Input v-model="formObj.item2" style="width:120px"></Input>
							</Col>
							<Col span="3"> 需求品目3:
							</Col>
							<Col span="5">
							<Input v-model="formObj.item3" style="width:120px"></Input>
							</Col>
						</Row>
					</Row>
				</Form>
				<Form id="npbasic" v-else>
					<Row>
						<Col span="3"> 开标时间:
						</Col>
						<Col span="21">
						<DatePicker type="datetime" v-model="formObj.start" format="yyyy-MM-dd HH:mm" placeholder="开始时间" style="width: 200px"></DatePicker>
						&nbsp;~&nbsp;
						<DatePicker type="datetime" v-model="formObj.end" format="yyyy-MM-dd HH:mm" placeholder="预计结束时间" style="width: 200px"></DatePicker>
						评标时间约为:{{timeDifference}} 小时
						</Col>
					</Row>
					<Row>
						<Col span="3"> 会议主持:
						</Col>
						<Col span="8">
						<Input style="width:120px" v-model="formObj.abpRoomPlus.host" readonly></Input>
						<Button type="primary" size="small" style="margin: 0 5px;" @click="addUserModal('host')">添加/修改</Button>
						</Col>
						<Col span="3"> 协助人员:
						</Col>
						<Col span="8">
						<Input style="width:120px" v-model="formObj.abpRoomPlus.support" readonly></Input>
						<Button type="primary" size="small" style="margin: 0 5px;" @click="addUserModal('support')">添加/修改</Button>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 评标方式:
						</Col>
						<Col span="6">
						<Select style="width:120px" v-model="formObj.abpRoomPlus.evaluatingMethods">
							<Option value="电子评标">电子评标</Option>
							<Option value="纸质">纸质</Option>
							<Option value="交易中心">交易中心</Option>
							<Option value="其他">其他</Option>
						</Select>
						</Col>
						<Col span="3"> 是否需要演示:
						</Col>
						<Col span="6">
						<Select style="width:120px" v-model="formObj.abpRoomPlus.ifShow">
							<Option value="是">是</Option>
							<Option value="否">否</Option>
						</Select>
						</Col>
					</Row>
					<Row v-show="thisClickRoom.会议室名称 == '其他' || thisClickRoom.会议室名称 == '其它'">
						<Col span="3"> 外出场地:
						</Col>
						<Col span="21">
						<Input v-model="formObj.abpRoomPlus.outgoing"></Input>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 备注:
						</Col>
						<Col span="21">
						<Input type="textarea" v-model="formObj.abpRoomPlus.opinions"></Input>
						</Col>
					</Row>
					<!-- <Row>
						<h3>开标信息</h3>
						<Col span="3"> 专家人数:
						</Col>
						<Col span="6">
						<Input style="width:120px" v-model="formObj.abpRoomPlus.host"></Input>
						</Col>
						<Col span="3"> 采购人代表:
						</Col>
						<Col span="6">
						<Input style="width:120px" v-model="formObj.abpRoomPlus.host"></Input>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 投标人数:
						</Col>
						<Col span="6">
						<Input style="width:120px" v-model="formObj.abpRoomPlus.host"></Input>
						</Col>
						<Col span="3"> 会务跟进人员:
						</Col>
						<Col span="6">
						<Input style="width:120px" v-model="formObj.abpRoomPlus.host"></Input>
						</Col>
					</Row> -->
				</Form>
			</div>
			<Row>
				当天已存在预约:
				<span v-if="thisClickObj.length == 0">暂无</span>
			</Row>
			<template v-show="thisClickObj.length > 0">
				<Row v-for="(item,key) in thisClickObj">
					<Col span="10" v-if="item.clProjectDb!=null"> {{item.clProjectDb.projectName}}
					<!-- <template v-if="item.rate == 0">(无效)</template> -->
					</Col>
					<Col span="10" v-else> {{item.clMeetingRoomExt.title}}
					<!-- <template v-if="item.rate == 0">(无效)</template> -->
					</Col>
					<Col span="8" style="text-align:center">
						{{item.beginTime|filterTime3}}&nbsp;~&nbsp;{{item.endTime|filterTime3}}
					</Col>
					<Col span="6">
					<Button type="primary" size="small" @click="showDetailModal(item)" style="margin-right:5px;">查看详细</Button>
					<Button type="primary" size="small" :disabled="Boolean(item.isConfirm)" @click="confirmUsed(item)" style="margin-right:5px;">
						{{ item.isConfirm ? '已使用' : '确认使用' }}
					</Button>
					<!-- <template v-if="item.creator == formObj.creator && item.rate == 1 && ifBook == true">
						<Button type="error" size="small" @click="doValid(item,0)">置无效</Button>
					</template>
					<template v-else-if="item.creator == formObj.creator && item.rate == 0 && ifBook == true">
						<Button type="success" size="small" @click="doValid(item,1)">置有效</Button>
					</template>
					<template v-else-if="item.creator != formObj.creator && item.rate == 0 && ifBook == true">
						<Button type="error" size="small" disabled="disabled">已无效</Button>
					</template> -->
					<Button type="error" size="small" @click="delete_book(item)" v-if="deletable">删除</Button>
					</Col>
				</Row>
			</template>

			<div slot="footer">
				<Button @click="roomBookModal = false">关闭</Button>
				<Button :disabled="replenishRoom ? false : btn_disabled" type="primary" style="margin-left:15px" @click="doRoomBook">会议预约</Button>
			</div>
		</Modal>
		<div v-if="detailBookModal">
			<Modal v-model="detailBookModal" title="会议详细信息" width="700px" id="roomView2" :mask-closable="false">
				<div style="padding-bottom:5px;color:#ff9900;">企业微信日程目前只支持修改时间及人员信息（其他信息需手动修改企业微信日程内容）</div>
				<div v-if="!!detailFormObj.clProjectDb">
					<Row>
						<Col span="24"> {{detailFormObj.clProjectDb.projectName}}
						</Col>
					</Row>
					<Row style="margin-bottom: 15px">
						<Col span="25">
						<Col span="3">会议室：</Col>
				    	   <Select multiple="multiple" v-model="detail_multi" style="width:300px" :disabled="!(ifBook == true)">
						      <Option v-for="item in roomList" :value="item['会议室名称']">{{item['会议室名称']}}</Option>
				    	   </Select>
				    	 </Col>
				    </Row>
					<Row>
						<Col span="3"> 开标时间:
						</Col>
						<Col span="21">
						<DatePicker type="datetime" v-model="detailFormObj.beginTime" format="yyyy-MM-dd HH:mm" placeholder="开始时间" style="width: 180px" :readonly="!(ifBook == true)"></DatePicker>
						&nbsp;~&nbsp;
						<DatePicker type="datetime" v-model="detailFormObj.endTime" format="yyyy-MM-dd HH:mm" placeholder="预计结束时间" style="width: 180px" :readonly="!(ifBook == true)"></DatePicker>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 会议主持:
						</Col>
						<Col span="6">
						<Input style="width:120px" v-model="detailFormObj.compere" :readonly="!(ifBook == true)"></Input>
						</Col>
						<Col span="3"> 协助人员:
						</Col>
						<Col span="6">
						<Input style="width:120px" v-model="detailFormObj.assist" :readonly="!(ifBook == true)"></Input>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 评标方式:
						</Col>
						<Col span="6">
						<Select style="width:120px" v-model="detailFormObj.bidMethod" :disabled="!(ifBook == true)">
							<Option value="电子评标">电子评标</Option>
							<Option value="纸质">纸质</Option>
							<Option value="交易中心">交易中心</Option>
							<Option value="其他">其他</Option>
						</Select>
						</Col>
						<Col span="3"> 是否演示:
						</Col>
						<Col span="6">
						<Select style="width:120px" v-model="detailFormObj.isDemo" :disabled="!(ifBook == true)">
							<Option value="是">是</Option>
							<Option value="否">否</Option>
						</Select>
						</Col>
					</Row>
					<!-- <Row v-show="thisClickRoom.会议室名称 == '其他' || thisClickRoom.会议室名称 == '其它'">
						<Col span="3"> 外出场地:
						</Col>
						<Col span="21">
						<Input v-model="detailFormObj.abpRoomPlus.outgoing" :readonly="!(detailFormObj.creator == thisUser.name && ifBook == true)"></Input>
						</Col>
					</Row> -->
					<Row>
						<Col span="3"> 备注:
						</Col>
						<Col span="21">
						<Input type="textarea" v-model="detailFormObj.comment" :readonly="!(ifBook == true)"></Input>
						</Col>
					</Row>
				</div>
				<div v-else>
					<Row style="margin-bottom: 15px">
					<Col span="25">
					<Col span="3">会议室：</Col>
				       <Select multiple="multiple" v-model="detail_multi" style="width:300px" :disabled="!(ifBook == true)">
					      <Option v-for="item in roomList" :value="item['会议室名称']">{{item['会议室名称']}}</Option>
				       </Select>
				
				     </Col>
				    </Row>
					<Row>
						<Col span="3"> 会议类别:
						</Col>
						<Col span="9">
						<Select v-model="detailFormObj.clMeetingRoomExt.meetingType" style="width:120px" :disabled="!(ifBook == true)">
							<Option v-for="(item,index) in  typeList" :key="index" :value="item">{{item}}</Option>
						</Select>
						</Col>
						<Col span="3" v-if="detailFormObj.clMeetingRoomExt.meetingType=='论证'"> 论证时间:
						</Col>
						<Col span="9" v-if="detailFormObj.clMeetingRoomExt.meetingType=='论证'">
						<DatePicker type="datetime" v-model="detailFormObj.clMeetingRoomExt.argumentTime" format="yyyy-MM-dd HH:mm" placeholder="" style="width: 180px" :readonly="!(ifBook == true)"></DatePicker>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 部门/分公司:
						</Col>
						<Col span="6">
						<!-- <Input v-model="detailFormObj.clMeetingRoomExt.filiale" style="width:120px" :readonly="!(ifBook == true)"></Input> -->
						<Select v-model="detailFormObj.clMeetingRoomExt.filiale" style="width:120px">
							<Option
								v-for="area in areaArr"
								:key="area.id"
								:value="area.name"
								:readonly="!(ifBook == true)"
							>{{area.name}}</Option>
						</Select>
						</Col>
						<Col span="2"> 主持人:
						</Col>
						<Col span="6">
						<Input readonly v-model="detailFormObj.clMeetingRoomExt.compere" style="width:100px"></Input>
						<Button type="primary" size="small" @click="addUserModal('extCompere')">添加/修改</Button>
						</Col>
						<Col span="2"> 专家数量:
						</Col>
						<Col span="4">
						<Input v-model="detailFormObj.clMeetingRoomExt.expertNum" style="width:120px;margin-left:5px" :readonly="!(ifBook == true)"></Input>
						</Col>
					</Row>
					</Row>
					<Row>
						<Col span="3"> 会议时间:
						</Col>
						<Col span="21">
						<DatePicker type="datetime" v-model="detailFormObj.beginTime" format="yyyy-MM-dd HH:mm" placeholder="Select date and time" style="width: 180px" :readonly="!(ifBook == true)"></DatePicker>
						&nbsp;~&nbsp;
						<DatePicker type="datetime" v-model="detailFormObj.endTime" format="yyyy-MM-dd HH:mm" placeholder="Select date and time" style="width: 180px" :readonly="!(ifBook == true)"></DatePicker>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 会议名称:
						</Col>
						<Col span="21">
						<Input v-model="detailFormObj.clMeetingRoomExt.title" :readonly="!(ifBook == true)"></Input>
						</Col>
					</Row>
					<Row>
						<Col span="3"> 备注:
						</Col>
						<Col span="21">
						<Input type="textarea" v-model="detailFormObj.clMeetingRoomExt.comment" :readonly="!(ifBook == true)"></Input>
						</Col>
					</Row>
					<Row v-if="detailFormObj.clMeetingRoomExt.meetingType=='论证'">
						<Row>
							<Col span="3"> 采购单位名称:
							</Col>
							<Col span="21">
							<Input v-model="detailFormObj.clMeetingRoomExt.purchaser" :readonly="!(ifBook == true)"></Input>
							</Col>
						</Row>
						<Row>
							<Col span="3"> 联系人:
							</Col>
							<Col span="5">
							<Input v-model="detailFormObj.clMeetingRoomExt.contacts" style="width:120px" :readonly="!(ifBook == true)"></Input>
							</Col>
							<Col span="3"> 联系电话:
							</Col>
							<Col span="5">
							<Input v-model="detailFormObj.clMeetingRoomExt.tel" style="width:120px" :readonly="!(ifBook == true)"></Input>
							</Col>
							<Col span="3"> 项目名称:
							</Col>
							<Col span="5">
							<Input v-model="detailFormObj.clMeetingRoomExt.projectName" style="width:120px" :readonly="!(ifBook == true)"></Input>
							</Col>
						</Row>
						<Row>
							<Col span="4"> 采购人代表人数:
							</Col>
							<Col span="3">
							<Input v-model="detailFormObj.clMeetingRoomExt.purchaserNum" style="width:50px" :readonly="!(ifBook == true)"></Input>
							</Col>
							<Col span="4"> 是否有申请理由:
							</Col>
							<Col span="3">
							<Select style="width:70px" v-model="detailFormObj.clMeetingRoomExt.isReason" :disabled="!(ifBook == true)">
								<Option value="是">是</Option>
								<Option value="否">否</Option>
							</Select>
							</Col>
							<Col span="4"> 是否有用户需求:
							</Col>
							<Col span="3">
							<Select style="width:70px" v-model="detailFormObj.clMeetingRoomExt.isNeed" :disabled="!(ifBook == true)">
								<Option value="是">是</Option>
								<Option value="否">否</Option>
							</Select>
							</Col>
						</Row>
						<Row>
							<Col span="3"> 需求品目1:
							</Col>
							<Col span="5">
							<Input v-model="detailFormObj.clMeetingRoomExt.item1" style="width:120px" :readonly="!(ifBook == true)"></Input>
							</Col>
							<Col span="3"> 需求品目2:
							</Col>
							<Col span="5">
							<Input v-model="detailFormObj.clMeetingRoomExt.item2" style="width:120px" :readonly="!(ifBook == true)"></Input>
							</Col>
							<Col span="3"> 需求品目3:
							</Col>
							<Col span="5">
							<Input v-model="detailFormObj.clMeetingRoomExt.item3" style="width:120px" :readonly="!(ifBook == true)"></Input>
							</Col>
						</Row>
					</Row>
				</div>
				<div slot="footer">
					<Button @click="detailBookModal = false">关闭</Button>
					<template v-if="ifBook == true">
						<Button type="primary" @click="doEditBook">修改</Button>
					</template>
					<!-- <Button :disabled="btn_disabled" type="primary"style="margin-left:15px" @click="doRoomBook">会议预约</Button> -->
				</div>
			</Modal>
			<!-- 添加修改人员 -->
			<Modal v-model="addUserVisible" title="人员信息">
				请输入一个且正确的姓名：
				<Input v-model="inputUser" style="width: 200px;"></Input>
				<Button type="primary" size="small" style="margin: 0 5px;" @click="addNewuser('add')">添加</Button>
				<Button type="primary" size="small" style="margin: 0 5px;" @click="addNewuser('cover')">覆盖</Button>
				<div slot="footer">
					<Button @click="addUserVisible=false">取消</Button>
				</div>
			</Modal>
		</div>
		<div v-else>
			<!-- 添加修改人员 -->
			<Modal v-model="addUserVisible" title="人员信息">
				请输入一个且正确的姓名：
				<Input v-model="inputUser" style="width: 200px;"></Input>
				<Button type="primary" size="small" style="margin: 0 5px;" @click="addNewuser('add')">添加</Button>
				<Button type="primary" size="small" style="margin: 0 5px;" @click="addNewuser('cover')">覆盖</Button>
				<div slot="footer">
					<Button @click="addUserVisible=false">取消</Button>
				</div>
			</Modal>
		</div>
	</div>
</template>
<script>
import ajax from '../../lib/ajax';
import requestUrls from '@/lib/requestUrls'
import sendMessage from '@/lib/message'
import md5 from 'md5'
import { formatDate } from '@/lib/tool'

export default {
	props: {
		projectData: {
			default: () => {
				return {
					id: 0
				}
			}
		},
		backable: {
			default: true
		},
		argumentData: {
			default: () => {
				return {
					id: 0
				}
			}
		}
	},
	data() {
		return {
			addType: '',
			inputUser: '',
			addUserVisible: false,
			isgetting: false,//判断是否正在getdata
			detailBookModal: false,
			roomBookModal: false,
			btn_disabled: false,
			ifBook: false,
			typeList:['例会','论证','节假','培训','其他'],//会议类型
			nowTime: "",
			selectDate: "",//当前选择日期
			timeArr: [],//当前日期对象
			roomList: [],//会议室清单
			dateRate: [
				{
					weekDay: "周日",
					weekDate: "",
					totalDate: "",
				},
				{
					weekDay: "周一",
					weekDate: "",
					totalDate: "",
				},
				{
					weekDay: "周二",
					weekDate: "",
					totalDate: "",
				},
				{
					weekDay: "周三",
					weekDate: "",
					totalDate: "",
				},
				{
					weekDay: "周四",
					weekDate: "",
					totalDate: "",
				},
				{
					weekDay: "周五",
					weekDate: "",
					totalDate: "",
				},
				{
					weekDay: "周六",
					weekDate: "",
					totalDate: "",
				}
			],//当前周对象 
			dataTable: {

			},//具体会议室-天-预约 对象存储
			cityList: [],//地区下拉框
			thisUser: "",
			thisCity: "",//当前地区
			thisClickObj: [],//当前点击对象
			// deletable: true,//权限设置 是否可删除
			thisStart: "",
			thisEnd: "",

			thisClickRoom: {},//当前点击会议室对象
			thisClickDay: "",//当前日期(时间戳)
			thisPlus: {},//扩展表对象

			timeDifference: 0,//时间差对象
			formObj: {
				title: "",
				start: "",
				end: "",
				type: "",
				rate: "1",
				roomId: "",
				content: "",
				creator: "",
				roomName: "",
				area: "",
				site: "",//开会地点
				argumentTime: "",//论证时间
				compere: "",//主持人
				expertNum: "",//专家数量
				purchaser: "",//采购单位名称
				contacts: "",//联系人
				tel: "",//联系电话
				projectName: "",//项目名称
				purchaserNum: "",//采购人代表人数
				isReason: "",//是否有申请理由
				isNeed: "",//是否有用户需求
				item1: "",//项目需求品目1
				item2: "",//项目需求品目2
				item3: "",//项目需求品目3
				abpRoomPlus: {
					npid: "",
					host: "",
					support: "",
					evaluatingMethods: "",
					ifShow: "",
					outgoing: "",
					opinions: "",
					purchaser: "",
					projectName: "",
					purchaserNum: "",
				}
			},//预约表
			detailFormObj: {
				id: "",
				title: "",
				start: "",
				end: "",
				type: "",
				rate: "",
				roomId: "",
				content: "",
				creator: "",
				roomName: "",
				area: "",
				abpRoomPlus: {
					id: "",
					npid: "",
					host: "",
					support: "",
					evaluatingMethods: "",
					ifShow: "",
					outgoing: "",
					opinions: "",
					purchaser: "",
					projectName: "",
					purchaserNum: "",
				}
			},
			emptyObj: {

			},
			// detailObj:{

			// },
			thisBasicForm: {

			},
			thisNpData: [],
			thisAGDate: [],//论证数据,替换argumentData
			projectForm: {
				expertNum: '',
				purchaserNum: '',
				bidderNum: ''
			},
			multi_room: '',//多会议室列表
			detail_multi: '',//预约详细显示会议室列表
			// replenishRoom: false,
			// roles: []
			areaArr: [],
		}
	},
	async created() {//触发了getMyRoom
		var self = this;
		// 权限
		if (!this.$store.state.session.user) {
			await this.$store.dispatch({
				type: 'session/init'
			})
		}
		// let rep = await ajax.get(requestUrls.Session.GetCurrentUser)
		// this.roles = rep.data.result.roleNames
		// if (rep.data.result.roleNames.indexOf('补会议数据') !== -1) {
		// 	this.replenishRoom = true
		// }

		// 会议室删除角色，可删除全部会议室
		// self.deletable = rep.data.result.roleNames.indexOf('会议室删除') + 1

		self.thisCity = "广州"
		self.getArea()
		//this.getMyRoom();            
		self.nowTime = (new Date()).getTime() / 1000;
		self.thisUser = self.$store.state.session.user
		self.formObj.creator = self.$store.state.session.user.name
		self.emptyObj = await JSON.parse(JSON.stringify(self.formObj))
		self.emptyObj.area = self.formObj.area
	},
	computed: {
		roles() {
			return this.$store.state.session.roleNames
		},
		replenishRoom() {
			return this.$store.getters['session/hasRoles']('补会议数据')
		},
		deletable() {
			return this.$store.getters['session/hasRoles']('会议室删除')
		},
		// 客户助理 项目助理 跟进人员
		infouserList () {
			const infoUser = []
			const { am, aid, merchandiser } = this.projectData
			if (am) {
				am.split(',').forEach(item => {
					infoUser.push({
						userid: item
					})
				})
			}
			if (aid) {
				aid.split(',').forEach(item => {
					infoUser.push({
						userid: item
					})
				})
			}
			if (merchandiser) {
				merchandiser.split(',').forEach(item => {
					infoUser.push({
						userid: item
					})
				})
			}
			return infoUser
		}
	},
	watch: {
		'selectDate'(val) {
			val = val.toString()
			if(val.indexOf('GMT')==-1){
				return
			}
			this.getMyRoom();
		},
		'thisCity'(val) {
			this.formObj.area = val;
			this.emptyObj.area = val;
			if(this.projectData.id!=0){
				this.getMyRoom();
			}else if(!this.isgetting){
				this.getMyRoom();
			}
			// if(!this.isgetting||this.projectData.id!=0||this.argumentData.id!=0){
			// if(!this.isgetting){
			// 	this.getMyRoom();
			// }
		},
		'formObj.start'(val) {
			if (!!val && !!this.formObj.end) {
				let startTime = new Date(val).getTime()
				let endTime = new Date(this.formObj.end).getTime()
				this.timeDifference = ((endTime - startTime) / 3600000).toFixed(1)
			}
		},
		'formObj.end'(val) {
			if (!!val && !!this.formObj.start) {
				let startTime = new Date(this.formObj.start).getTime()
				let endTime = new Date(val).getTime()
				this.timeDifference = ((endTime - startTime) / 3600000).toFixed(1)
			}
		},
		'projectData'(val) {
			this.getExist(val)
			this.projectForm.expertNum = val.expertNum
			this.projectForm.purchaserNum = val.purchaserNum
			this.projectForm.bidderNum = val.bidderNum
		},
		async argumentData(val){
			// this.getAgData(val.clMeetingRoomExt.argumentId)
			this.thisAGDate = val
			if(val.id!=0){
				// this.typeList = ['论证']
				// this.formObj.type= '论证'
				this.isgetting = true
				this.thisCity = this.argumentData.district?this.argumentData.district:this.argumentData.site
				this.$nextTick(function(){
					if(val.clMeetingRoomExt.id!=0){
						this.selectDate = val.beginTime.split('T')[0]
						// let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {//获取该预约会议室id
						// 	params:{
						// 		filter: 'clMeetingRoomExtId==' + val.clMeetingRoomExt.id
						// 	}
						// })
						// this.argumentData.RoomID = rep.data.result.items[0].id
					}else{
						this.selectDate = new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate()
					}
					setTimeout(() => {
						this.isgetting = false
					}, 1000);
				})
			}
		},
		addUserVisible (val) {
			if (val) {
				this.inputUser = ''
			}
		}
	},
	filters: {
		filterTime: function (val) {
			return (val.replace("T", " ")).substring(16, 10);
		},
		filterTime2: function (val) {
			return val.replace(' 00:00:00','');
			//return val.substring(0, 10);
		},
		filterTime3: function (val) {
			return val.replace("T", " ");
		},
		formatDate: function (nS) {
			var now = new Date(nS * 1000);
			var year = now.getYear() + 1900;
			var month = now.getMonth() + 1;
			var date = now.getDate();
			var hour = now.getHours();
			var minute = now.getMinutes();
			var second = now.getSeconds();
			if (month < 10) month = "0" + month;
			if (hour < 10) hour = "0" + hour;
			if (minute < 10) minute = "0" + minute;
			if (second < 10) second = "0" + second;
			if (date < 10) date = "0" + date;
			return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
		}, //时间戳转时间格式    
	},
	methods: {
		// change_end(){
		// 	this.formObj.end = this.formObj.start
		// },
		addNewuser (type) {
			const userData = this.userGetSetData('get', this.addType)
			// 覆盖
			if (type === 'cover') {
				this.userGetSetData('set', this.addType, this.inputUser)
			}
			// 添加
			if (type === 'add') {
				let addData = ''
				if (userData.length) {
					const currentUser = this.inputUser ? `,${this.inputUser}` : ''
					addData = userData + currentUser
				} else {
					addData = this.inputUser
				}
				this.userGetSetData('set', this.addType, addData)
			}
			this.addUserVisible = false
		},
		userGetSetData (type, addType, data) {
			let getData = ''
			if (type === 'get') {
				switch (addType) {
					case 'extCompere':
						getData = this.detailFormObj.clMeetingRoomExt.compere
						break
					case 'support':
						getData = this.formObj.abpRoomPlus.support
						break
					case 'compere':
						getData = this.formObj.compere
						break
					case 'host':
						getData = this.formObj.abpRoomPlus.host
						break
				}
			}
			if (type === 'set') {
				switch (addType) {
					case 'extCompere':
						this.detailFormObj.clMeetingRoomExt.compere = data
						break
					case 'support':
						this.formObj.abpRoomPlus.support = data
						break
					case 'compere':
						this.formObj.compere = data
						break
					case 'host':
						this.formObj.abpRoomPlus.host = data
						break
				}
			}
			return getData
		},
		addUserModal (type) {
			this.addType = type
			this.addUserVisible = true
		},
		getExist(obj) {
			var self = this;
			self.formObj.abpRoomPlus.npid = obj.id;
			self.formObj.title = obj.projectName;
			self.formObj.content = obj.projectName + "开评标会议";
			self.formObj.type = "开评标";
			self.getNpData(obj.id);
		},
		backProjectList() {
			this.$emit('back')
		},
		handleTime(start, end) {
			var self = this;
			let startTime = new Date(start).getTime()
			let endTime = new Date(end).getTime()
			if (!!start && !!end) {
				if ((((startTime / 1000) - self.thisClickDay >= 86400) || ((startTime / 1000) - self.thisClickDay < 0)) && !!start) {
					self.$Message.error("开始时间必须当天");
					// self.btn_disabled = true;
					return false;
				}
				if (!!start && !!end) {
					// self.btn_disabled = false;
					self.timeDifference = ((endTime - startTime) / 3600000).toFixed(1)
				}
				if (self.timeDifference < 0) {
					self.$Message.error("时间选择有误");
					self.timeDifference = 0;
					// self.btn_disabled = true;
					self.formObj.end = self.formObj.start;
					return false;
				}
				return self.handleTimeCheck(startTime, endTime);
			}
			this.$Message.error('会议时间不能为空')
			return false
		},//基础时间检查
		async handleTimeCheck(start, end) {
			var self = this;
			var state = true;
			//检查一,当前页面下列  
			for (var i = 0; i < self.thisClickObj.length; i++) {
				var thisStart = (new Date(self.thisClickObj[i]["start"])).getTime();
				var thisEnd = (new Date(self.thisClickObj[i]["end"])).getTime();
				if ((thisStart < start && start < thisEnd) || (thisStart < end && end < thisEnd)) {
					if (self.thisClickObj[i].rate != 0) {
						state = false;
					}
				}
			}
			let startTime = self.$options.filters.formatDate(start / 1000)
			let endTime = self.$options.filters.formatDate(end / 1000)
			let new_room = self.multi_room.join(`")||roomName.Contains("`)
			// return
			let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {
				params: {
					filter: "(((filiale==\"" + self.formObj.area + "\")||(clMeetingRoomExt.site==\"" + self.formObj.area + "\"))&&(roomName.Contains(\"" +
						// self.formObj.roomName
						new_room + "\")))&&((\""
						+
						startTime
						+ "\"<=beginTime&&beginTime<=\"" +
						endTime
						+ "\")||(\"" +
						startTime
						+ "\"<=endTime&&endTime<=\"" +
						endTime
						+ "\")||(beginTime<\"" +
						startTime
						+ "\"&&endTime>\"" +
						endTime
						+ "\")||(endTime==null&&beginTime<=\"" +
						startTime 
						+ "\"&&beginTime>=\"" +
						startTime.substring(0,10).replace(' ','')
						+"\"))"//解决endtime为null的问题
					//未解决endtime为null的问题
					// ||(beginTime<\"" +
					// startTime
					// + "\"&&endTime==null)
				}
			})
			if (rep.data.result.items.length > 0) {
				state = false;
			}
			//检查二， 查后台
			if (!state) {
				self.$Message.error("时间预约存在冲突");
				// self.btn_disabled = true;
			}
			return state
		},//冲突时间检查
		createWeek(date) {
			var self = this;
			self.timeArr = [];
			var t;
			if (!!date) {
				t = new Date(date);
			} else {
				t = new Date();
			}
			t.setTime(t.getTime() - t.getDay() * 24 * 60 * 60 * 1000);//获取这周的第一天(周日)
			var arr = [];
			for (var i = 0; i < 7; i++) {
				var thisDate = t.getDate();
				var thisTime = parseInt(self.getTimeArr(t));
				for (var j = 0; j < self.roomList.length; j++) {
					self.dataTable[self.roomList[j]["会议室名称"]][thisTime] = [];
				}
				self.thisBasicForm = self.dataTable;
				self.dateRate[i]["weekDate"] = thisDate;
				self.dateRate[i]["totalDate"] = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate() + " 00:00:00";
				t.setDate(t.getDate() + 1);
				self.timeArr.push((new Date(self.dateRate[i]["totalDate"])).getTime() / 1000);
				if (i == 0) {
					self.thisStart = self.dateRate[i]["totalDate"];
				}
				if (i == 6) {
					self.thisEnd = self.dateRate[i]["totalDate"];
				}
			}
			self.getData();
		},//生成一周对象
		async getArea() {
			var self = this;
			let rep = await ajax.get(requestUrls.CLDistrict.GetListWithoutRole);
			self.cityList = rep.data.result.items;
			let rep1 = await ajax.get(requestUrls.CLDistrict.GetList)
			if (rep1.data.success && rep1.data.result.items.length > 0) {
				this.areaArr = rep1.data.result.items
			}
		},//获取地区
		async getMyRoom() {
			let self = this
			self.dataTable = {}
			let thisCity = self.thisCity
			ajax.get(requestUrls.AbpDataDict.GetList, {
				params: {
					filter: `itemName=="${thisCity}"`
				}
			}).then(async room => {
				if (room.data.result.items.length > 0) {
					let test = await this.getDataDict('会议室',0,room.data.result.items[0].id)
					let temp = test.map(next => {
						return {
							"ID": parseInt(next.itemCode),
							"会议室名称": next.itemName
						}
					})
					self.roomList = temp;
					if (self.roomList.length > 0) {
						for (var i = 0; i < self.roomList.length; i++) {
							self.dataTable[self.roomList[i]["会议室名称"]] = {};
						}
						if (!!self.selectDate) {
							self.createWeek(self.selectDate);
						}
						else {
							self.createWeek();
						}
					}
				} else {
					self.roomList = []
				}
			})
			// else {
			// 	self.$Message.info("当前地区无会议室")
			// }
		},//获取已选地区会议室列表
		async getData() {
			var self = this;
			let qq = self.$options.filters.formatDate(self.timeArr[6] + 86400);//下一周周日的日期
			self.dataTable = JSON.parse(JSON.stringify(self.thisBasicForm))
			let filialeFilter = `filiale=="${self.thisCity}"`
			let siteFilter = `clMeetingRoomExt.site=="${self.thisCity}"`
			// if (self.thisCity === '军工事业部' || self.thisCity === '战略客户中心') {
			// 	filialeFilter += '||filiale=="广州"'
			// 	siteFilter += '||clMeetingRoomExt.site=="广州"'
			// }
			let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {
				params: {
					filter: `(${filialeFilter}||${siteFilter})` + "&&((\"" +
						self.thisStart
						+ "\"<=beginTime&&beginTime<=\"" +
						//self.thisEnd
						qq
						+ "\")||(\"" +
						self.thisStart
						+ "\"<=endTime&&endTime<=\"" +
						//self.thisEnd
						qq
						+ "\")||(beginTime<\"" +
						self.thisStart
						+ "\"&&endTime>\"" +
						//self.thisEnd
						qq
						+ "\"))"
					//filter:"(area==\""+self.thisCity+"\")&&((\""+self.thisStart+"\"<=start&&start<=\""+self.thisEnd+"\")||(\""+self.thisStart+"\"<=end&&end<=\""+self.thisEnd+"\"))"
				}
			})
			rep.data.result.items = await rep.data.result.items.filter((item, index) => {//过滤“/”的数据
				for (var key in self.dataTable) {
					if (item.roomName != null) {
						if (item.roomName.indexOf(key) > -1) {
							return true
						}
					}
				}
			})
			for (var i = 0; i < rep.data.result.items.length; i++) {//无结束时间的都意义为18：00
				rep.data.result.items[i].rate = 1;
				if (!rep.data.result.items[i].endTime) {
					rep.data.result.items[i].endTime = rep.data.result.items[i].beginTime.split('T')[0] + "T18:00:00"
				}
			}
			self.handleData(rep.data.result.items);
		},
		async getNpData(npid) {
			var self = this;
			let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {
				params: {
					filter: "projectId==" + npid
				}
			})
			for (var i = 0; i < rep.data.result.items.length; i++) {//无结束时间的都定义为18：00
				rep.data.result.items[i].rate = 1;
				if (!rep.data.result.items[i].endTime) {
					rep.data.result.items[i].endTime = rep.data.result.items[i].beginTime.split('T')[0] + "T18:00:00"
				}
			}
			self.thisNpData = rep.data.result.items;
			if(this.projectData.clMeetingRoom){
				this.isgetting = true
				this.thisCity = this.projectData.clMeetingRoom.filiale;
				this.$nextTick(function(){
					this.selectDate = this.projectData.clMeetingRoom.beginTime.split('T')[0];
					setTimeout(() => {
						this.isgetting = false
					}, 1000);
				})
			}else if(self.argumentData.id !== 0 && self.thisNpData.length>0){
				this.isgetting = true
				this.thisCity = self.thisNpData[0].filiale;
				this.$nextTick(function(){
					this.selectDate = self.thisNpData[0].beginTime.split('T')[0];
					setTimeout(() => {
						this.isgetting = false
					}, 1000);
				})
			}else if(this.projectData.district){
				this.isgetting = true
				this.thisCity = this.projectData.district
				this.$nextTick(function(){
					this.selectDate = new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate()
					setTimeout(() => {
						this.isgetting = false
					}, 1000);
				})
			}
		},
		async getAgData(Agid){
			let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {//获取该预约会议室id
				params:{
					filter: 'ClMeetingRoomExt.argumentid==' + Agid
				}
			})
			// var temp = this.argumentData
			// if(rep.data.result.items.length>0){
			// 	this.argumentData = {
			// 		argumentFull: temp.argumentFull,
			// 		argumentName: temp.argumentName,
			// 		argumentType: temp.argumentType,
			// 		...rep.data.result.items[0]
			// 	}
			// }else{
			// 	this.argumentData = {
			// 		argumentFull: temp.argumentFull,
			// 		argumentName: temp.argumentName,
			// 		argumentType: temp.argumentType,
			// 		clMeetingRoomExt: {
			// 			id: 0
			// 		},
			// 		id: temp.clMeetingRoomExt.argumentId
			// 	}
			// }
			var temp = this.thisAGDate
			if(rep.data.result.items.length>0){
				this.thisAGDate = {
					argumentFull: temp.argumentFull,
					argumentName: temp.argumentName,
					argumentType: temp.argumentType,
					...rep.data.result.items[0]
				}
			}else{
				this.thisAGDate = {
					argumentFull: temp.argumentFull,
					argumentName: temp.argumentName,
					argumentType: temp.argumentType,
					clMeetingRoomExt: {
						id: 0
					},
					id: temp.clMeetingRoomExt.argumentId
				}
			}
		},
		handleData(data) {
			// console.log(data)
			var self = this;
			if (!!data && data.length > 0) {
				data = JSON.parse(JSON.stringify(data));
				for (var i = 0; i < data.length; i++) {
					var thisObj = data[i];
					if (!!thisObj.roomName) {
						var start = new Date(thisObj["beginTime"].replace("T", " "));//预约具体开始
						var end = new Date(thisObj["endTime"].replace("T", " "));//预约具体结束
						var startAmp = self.getThisdayAmp(thisObj["beginTime"]);
						
						if (start.getDate() == end.getDate()) {
							if (thisObj.roomName.indexOf(',') != -1||thisObj.roomName.indexOf('，') != -1) {
								let rooms = []
								if(thisObj.roomName.indexOf(',') != -1){
									rooms = thisObj.roomName.split(',')
								}else{
									rooms = thisObj.roomName.split('，')
								}
								// this.$nextTick(()=>{
								for (var k = 0; k < rooms.length; k++) {
									var thisDate = start.getTime() / 1000;
									//self.dataTable[thisObj["roomName"]][thisDate].push(thisObj);
									// if (!self.dataTable[rooms[k]][startAmp]) {
									// }
									let isrepeat = false
									// console.log(startAmp)
									// console.log(self.dataTable[rooms[k]],self.dataTable[rooms[k]][startAmp])
									self.dataTable[rooms[k]][startAmp].forEach(filter=>{//判断重复
										if(filter.id==thisObj.id){
											isrepeat = true
										}
									})
									if(!isrepeat){
										self.$set(self.dataTable[rooms[k]][startAmp], self.dataTable[rooms[k]][startAmp].length, thisObj);
									}
								}
								// })
							} else {
								//var thisDate = start.getDate();
								var thisDate = start.getTime() / 1000;
								thisObj["roomName"] = thisObj["roomName"].replace('桂城交易所','桂城').replace(' ','')
								//self.dataTable[thisObj["roomName"]][thisDate].push(thisObj);
								if (!self.dataTable[thisObj["roomName"]][startAmp]) {
									continue
								}
								//
								let isrepeat = false
								self.dataTable[thisObj["roomName"]][startAmp].forEach(filter=>{//判断重复
									if(filter.id==thisObj.id){
										isrepeat = true
									}
								})
								if(!isrepeat){
									self.$set(self.dataTable[thisObj["roomName"]][startAmp], self.dataTable[thisObj["roomName"]][startAmp].length, thisObj);									
								}
							}
						} else {
							var startTime = start.getTime() / 1000;
							var endTime = end.getTime() / 1000;
							var thisArr = self.timeArr;
							var thisStart;
							var thisEnd;
							for (var j = 0; j < thisArr.length; j++) {
								if ((startTime <= thisArr[j] && thisArr[j] <= endTime) || (((new Date(startTime * 1000)).getDate() == (new Date(thisArr[j] * 1000)).getDate()) && thisArr[j] <= endTime)) {
									var endAmp = thisArr[j] + 86400;
									let thisobj2 = JSON.parse(JSON.stringify(thisObj));//中转对象及清除属性
									//var a = (new Date(thisArr[j]*1000)).getDate();
									var a = (new Date(thisArr[j] * 1000)).getTime() / 1000;
									if (thisObj.roomName.indexOf(',') != -1||thisObj.roomName.indexOf('，') != -1) {
										let rooms = []
										if(thisObj.roomName.indexOf(',') != -1){
											rooms = thisObj.roomName.split(',')
										}else{
											rooms = thisObj.roomName.split('，')
										}
										for (var k = 0; k < rooms.length; k++) {
											//
											let isrepeat = false
											self.dataTable[rooms[k]][a].forEach(filter=>{//判断重复
												if(filter.id==thisObj.id){
													isrepeat = true
												}
											})
											if(!isrepeat){
												self.$set(self.dataTable[rooms[k]][a], self.dataTable[rooms[k]][a].length, thisobj2);																					
											}
										}
									}else{
										//
										let isrepeat = false
										self.dataTable[thisObj["roomName"]][a].forEach(filter=>{//判断重复
											if(filter.id==thisObj.id){
												isrepeat = true
											}
										})
										if(!isrepeat){
											self.$set(self.dataTable[thisObj["roomName"]][a], self.dataTable[thisObj["roomName"]][a].length, thisobj2);																																
										}
									}
								}
							}
						}
					}
				}
			}
		},
		getTimeArr(val) {
			var result = new Date(val);
			result.setHours(0);
			result.setMinutes(0);
			result.setSeconds(0);
			return result.getTime() / 1000;
		},
		getThisdayAmp(val) {
			var self = this;
			var value = (new Date(val.replace("T", " "))).getTime() / 1000;
			var result;
			for (var i = 0; i < self.timeArr.length - 1; i++) {
				if (self.timeArr[i] <= value && value < self.timeArr[i + 1]) {
					result = self.timeArr[i];
				}
				if (self.timeArr[6] <= value && value <= self.timeArr[6] + 86400) {//显示周六
					result = self.timeArr[6];
				}
			}
			return result;
		},//时间处理
		showDetailModal(obj) {
			var self = this;
			var start = (new Date(obj.beginTime)).getTime() / 1000;
			self.detailFormObj = JSON.parse(JSON.stringify(obj));
			self.detailBookModal = true;
			self.detail_multi = self.detailFormObj.roomName.split(',')
			if (self.nowTime - start < 86400) {
				self.ifBook = true;
				//self.btn_disabled = false;
			}
			else {
				self.ifBook = false;
				//self.btn_disabled = true;
			}
		},
		showRoomModal(roomkey, itemkey, itemindex) {
			var self = this;

			self.formObj.roomId = self.roomList[roomkey]["ID"];
			self.formObj.roomName = self.roomList[roomkey]['会议室名称'];

			self.thisClickObj = self.dataTable[self.roomList[roomkey]['会议室名称']][itemkey];
			self.thisClickRoom = self.roomList[roomkey];
			//let space = self.thisClickRoom
			self.multi_room = [self.thisClickRoom.会议室名称];//预约时modal显示会议室
			self.thisClickDay = self.timeArr[itemindex];

			self.formObj.start = self.$options.filters.formatDate(self.thisClickDay)
			self.formObj.end = self.$options.filters.formatDate(self.thisClickDay)
			self.formObj.argumentTime = self.$options.filters.formatDate(self.thisClickDay)
			if (self.nowTime - self.thisClickDay < 86400) {
				self.ifBook = true;
				self.btn_disabled = false;
			}
			else {
				self.ifBook = false;
				self.btn_disabled = true;
			}
			self.roomBookModal = true;
		},//打开预约表
		async doEditBook() {
			if(this.detail_multi.length==0){
				this.$Message.error('请选择会议室')
				return
			}
			var self = this;
			var state = true;
			self.detailFormObj.beginTime = self.$options.filters.formatDate((new Date(self.detailFormObj.beginTime)).getTime() / 1000);
			self.detailFormObj.endTime = self.$options.filters.formatDate((new Date(self.detailFormObj.endTime)).getTime() / 1000);
			let newd_room = this.detail_multi.join(`")||roomName.Contains("`)
			// if(this.detail_multi.length>1){
			// 	newd_room = newd_room + `"&&roomName=="` + this.detail_multi.join(',')
			// }
			let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {
				params: {
					filter: "(((filiale==\"" + self.formObj.area + "\")||(clMeetingRoomExt.site==\"" +
						self.formObj.area + "\"))&&(roomName.Contains(\"" + newd_room
						// self.formObj.roomName 
						+ "\")))&&((\""
						+
						self.$options.filters.formatDate((new Date(self.detailFormObj.beginTime)).getTime() / 1000)
						+ "\"<=beginTime&&beginTime<=\"" +
						self.$options.filters.formatDate((new Date(self.detailFormObj.endTime)).getTime() / 1000)
						+ "\")||(\"" +
						self.$options.filters.formatDate((new Date(self.detailFormObj.beginTime)).getTime() / 1000)
						+ "\"<=endTime&&endTime<=\"" +
						self.$options.filters.formatDate((new Date(self.detailFormObj.endTime)).getTime() / 1000)
						+ "\")||(beginTime<\"" +
						self.$options.filters.formatDate((new Date(self.detailFormObj.beginTime)).getTime() / 1000)
						+ "\"&&endTime>\"" +
						self.$options.filters.formatDate((new Date(self.detailFormObj.endTime)).getTime() / 1000)
						+ "\")||(endTime==null&&beginTime<=\"" +
						self.$options.filters.formatDate((new Date(self.detailFormObj.beginTime)).getTime() / 1000)
						+ "\"&&beginTime>=\"" +
						self.$options.filters.formatDate((new Date(self.detailFormObj.beginTime)).getTime() / 1000).substring(0,10).replace(' ','')
						+"\"))"
				}
			});
			if (rep.data.result.items.length > 0) {
				for (var i = 0; i < rep.data.result.items.length; i++) {
					let thisObj = rep.data.result.items[i];
					if (thisObj.id != self.detailFormObj.id) {
						state = false;
					}
				}
			};
			let book_data = ''
			let stand = self.detailFormObj
			if (!!state) {
				if (self.detailFormObj.clProjectDb) {//项目预约修改
					book_data = {
						"clMeetingRoom": {
							id: stand.id,
							projectId: stand.projectId,
							// roomName: stand.roomName,
							roomName: self.detail_multi.join(','),
							filiale: stand.filiale,
							site: stand.site,
							beginTime: stand.beginTime,
							endTime: stand.endTime,
							compere: stand.compere,
							bidMethod: stand.bidMethod,
							isDemo: stand.isDemo,
							comment: stand.comment,
							assist: stand.assist
						}
					}
					await ajax.post('/api/services/app/ClMeetingRoom/CreateOrUpdate', book_data
					).then((res) => {
						self.detailBookModal = false;
						self.roomBookModal = false;
						self.$Message.info("修改成功")
						self.getData();
						self.getNpData(self.projectData.id);

						// 修改日程时间
						let attendeeList = []
						if (stand.compere !== '') {
							stand.compere.split(',').forEach(item => {
								attendeeList.push({
									userid: item
								})
							})
						}
						if (stand.assist !== '') {
							stand.assist.split(',').forEach(item => {
								attendeeList.push({
									userid: item
								})
							})
						}
						// 客户经理项目助理跟进人员
						if (this.infouserList.length) {
							attendeeList = attendeeList.concat(this.infouserList)
						}
						if (!attendeeList.length) {
							// 避免为空
							attendeeList.push({
								userid: self.$store.state.session.user.name
							})
						}
						const schedule = {
							extId: md5(res.data.result.id),
							organizer: self.$store.state.session.user.name, // 当前用户人员
							startDate: stand.beginTime,
							endDate: stand.endTime,
							attendeeList, // 参与者 主持人 协助人员
							summary: `${stand.bidMethod}-${self.projectData.projectShort}-${self.projectData.projectName}`,
							description: `${stand.comment}`,
							location: `${stand.site}-${self.detail_multi.join(',')}`,
							type: 'update'
						}
						sendMessage('schedule', schedule)

					})
				} else {
					stand.clMeetingRoomExt.argumentTime = self.$options.filters.formatDate((new Date(stand.clMeetingRoomExt.argumentTime)).getTime() / 1000);
					book_data = {
						id: stand.clMeetingRoomExt.id,
						title: stand.clMeetingRoomExt.title,
						comment: stand.clMeetingRoomExt.comment,
						meetingType: stand.clMeetingRoomExt.meetingType,
						beginTime: stand.beginTime,
						endTime: stand.endTime,
						filiale: stand.clMeetingRoomExt.filiale,
						// roomName: stand.roomName,
						roomName: self.detail_multi.join(','),
						site: stand.site,
						compere: stand.clMeetingRoomExt.compere,//主持人
						expertNum: stand.clMeetingRoomExt.expertNum,//专家数量
						argumentTime: stand.clMeetingRoomExt.argumentTime,//论证时间
						purchaser: stand.clMeetingRoomExt.purchaser,//采购单位名称
						contacts: stand.clMeetingRoomExt.contacts,//联系人
						tel: stand.clMeetingRoomExt.tel,//联系电话
						projectName: stand.clMeetingRoomExt.projectName,//项目名称
						purchaserNum: stand.clMeetingRoomExt.purchaserNum,//采购人代表人数
						isReason: stand.clMeetingRoomExt.isReason,//是否有申请理由
						isNeed: stand.clMeetingRoomExt.isNeed,//是否有用户需求
						item1: stand.clMeetingRoomExt.item1,//项目需求品目1
						item2: stand.clMeetingRoomExt.item2,//项目需求品目2
						item3: stand.clMeetingRoomExt.item3,//项目需求品目3
						argumentId:stand.clMeetingRoomExt.argumentId? stand.clMeetingRoomExt.argumentId:'',//具体非项目预约归属
					}
					await ajax.post('/api/services/app/ClMeetingRoom/CreateOrUpdateExt', book_data
					).then((res) => {
						self.detailBookModal = false;
						self.roomBookModal = false;
						self.$Message.info("修改成功")
						self.getData();
						if(this.argumentData.id!=0){
							this.getAgData(self.argumentData.clMeetingRoomExt.argumentId)
						}
						if(this.projectData.id!=0){
							this.getNpData(self.projectData.id)
						}
						// self.getNpData(self.projectData.id);

						// 添加日程时间
						let attendeeList = []
						if (stand.clMeetingRoomExt.compere !== '') {
							stand.clMeetingRoomExt.compere.split(',').forEach(item => {
								attendeeList.push({
									userid: item
								})
							})
						}
						// 客户经理项目助理跟进人员
						if (this.infouserList.length) {
							attendeeList = attendeeList.concat(this.infouserList)
						}
						if (!attendeeList.length) {
							// 避免为空
							attendeeList.push({
								userid: self.$store.state.session.user.name
							})
						}
						const schedule = {
							extId: md5(res.data.result.id),
							organizer: self.$store.state.session.user.name, // 当前用户人员
							startDate: stand.beginTime,
							endDate: stand.endTime,
							attendeeList, // 参与者 主持人 协助人员
							summary: stand.clMeetingRoomExt.title,
							description: `${stand.clMeetingRoomExt.comment}`,
							location: `${stand.site}-${self.detail_multi.join(',')}`,
							type: 'update'
						}
						sendMessage('schedule', schedule)

					})
				}
			} else {
				self.$Message.info("你修改的时间与现有会议冲突")
			}
		},
		async doRoomBook() {
			// 输入判断
			let isChecked = await this.handleTime(this.formObj.start, this.formObj.end)
			if (!isChecked) {
				return
			}
			if (this.formObj.end === '' || this.formObj.start === '') {
				this.$Message.error('请选择会议时间')
				return
			}
			// if (this.formObj.abpRoomPlus.host === '' && this.projectData.id != 0) {
			// 	this.$Message.error('请输入会议主持')
			// 	return
			// }
			// if (this.formObj.abpRoomPlus.support === '' && this.projectData.id != 0) {
			// 	this.$Message.error('请输入协助人员')
			// 	return
			// }
			if(this.multi_room.length==0){
				this.$Message.error('请选择会议室')
				return
			}
			if (this.formObj.abpRoomPlus.evaluatingMethods === '' && this.projectData.id != 0) {
				this.$Message.error('请选择评标方式')
				return
			}
			if (this.formObj.abpRoomPlus.ifShow === '' && this.projectData.id != 0) {
				this.$Message.error('请选择是否演示')
				return
			}
			if (this.formObj.type === '' && this.projectData.id == 0) {
				this.$Message.error('请选择会议类别')
				return
			}
			if (this.formObj.site === '' && this.projectData.id == 0) {
				this.$Message.error('请输入部门/分公司')
				return
			}
			if (this.formObj.title === '' && this.projectData.id == 0) {
				this.$Message.error('请选择会议名称')
				return
			}
			if (this.formObj.argumentTime === '' && this.formObj.type === '论证' && this.projectData.id == 0) {
				this.$Message.error('请选择论证时间')
				return
			}
			// if (this.formObj.content === '' && this.projectData.id == 0) {
			// 	this.$Message.error('请选择会议内容')
			// 	return
			// }
			// if (this.formObj.abpRoomPlus.host === '') {
			// 	this.$Message.error('请输入会议主持')
			// 	return
			// }
			if((this.argumentData.id!=0&&this.argumentData.clMeetingRoomExt.id!=0) || (this.thisNpData.length&&this.thisNpData[0].id)){
				this.$Message.error('该项目已预约，请勿重复预约！')
				return
			}
			var self = this;
			self.formObj.start = self.$options.filters.formatDate((new Date(self.formObj.start)).getTime() / 1000);
			self.formObj.end = self.$options.filters.formatDate((new Date(self.formObj.end)).getTime() / 1000);
			//self.formObj.end = new Date(self.formObj.end);
			let book_data = ''
			let stand = self.formObj
			let new_room = this.multi_room.join(',')
			if (self.formObj.abpRoomPlus.npid) {
				book_data = {
					"clMeetingRoom": {
						//id: "",
						projectId: stand.abpRoomPlus.npid,
						// roomName: stand.roomName,
						roomName: new_room,
						filiale: stand.area,
						site: stand.area,
						beginTime: stand.start,
						endTime: stand.end,
						compere: stand.abpRoomPlus.host,
						bidMethod: stand.abpRoomPlus.evaluatingMethods,
						isDemo: stand.abpRoomPlus.ifShow,
						comment: stand.abpRoomPlus.opinions,
						assist: stand.abpRoomPlus.support
					}
				}
				await ajax.post('/api/services/app/ClMeetingRoom/CreateOrUpdate', book_data).then((res) => {
					self.roomBookModal = false;
					self.formObj = JSON.parse(JSON.stringify(self.emptyObj));
					if (self.projectData.id != 0) {
						self.getExist(self.projectData)
					}else{
						self.getNpData(self.projectData.id)
					}
					self.$Message.info("预约成功")
					self.getData();

					// 添加日程时间
					let attendeeList = []
					if (stand.abpRoomPlus.host !== '') {
						stand.abpRoomPlus.host.split(',').forEach(item => {
							attendeeList.push({
								userid: item
							})
						})
					}
					if (stand.abpRoomPlus.support !== '') {
						stand.abpRoomPlus.support.split(',').forEach(item => {
							attendeeList.push({
								userid: item
							})
						})
					}
					// 客户经理项目助理跟进人员
					if (this.infouserList.length) {
						attendeeList = attendeeList.concat(this.infouserList)
					}
					if (!attendeeList.length) {
						// 避免为空
						attendeeList.push({
							userid: self.$store.state.session.user.name
						})
					}
					const schedule = {
						extId: md5(res.data.result.id),
						organizer: self.$store.state.session.user.name, // 当前用户人员
						startDate: stand.start,
						endDate: stand.end,
						attendeeList, // 参与者 主持人 协助人员
						summary: `${stand.abpRoomPlus.evaluatingMethods}-${self.projectData.projectShort}-${self.projectData.projectName}`,
						description: `${stand.abpRoomPlus.opinions}`,
						location: `${stand.area}-${new_room}`
					}
					sendMessage('schedule', schedule)

				})
			} else {
				book_data = {
					title: stand.title,
					comment: stand.content,
					meetingType: stand.type,
					beginTime: stand.start,
					endTime: stand.end,
					filiale: stand.site,
					// roomName: stand.roomName,
					roomName: new_room,
					site: stand.area,
					compere: stand.compere,//主持人
					expertNum: stand.expertNum,//专家数量
					argumentId: self.argumentData.id!=0? self.argumentData.id:''
				}
				if (stand.type == "论证") {
					stand.argumentTime = self.$options.filters.formatDate((new Date(stand.argumentTime)).getTime() / 1000);
					book_data = {
						...book_data,
						argumentTime: stand.argumentTime,//论证时间
						purchaser: stand.purchaser,//采购单位名称
						contacts: stand.contacts,//联系人
						tel: stand.tel,//联系电话
						projectName: stand.projectName,//项目名称
						purchaserNum: stand.purchaserNum,//采购人代表人数
						isReason: stand.isReason,//是否有申请理由
						isNeed: stand.isNeed,//是否有用户需求
						item1: stand.item1,//项目需求品目1
						item2: stand.item2,//项目需求品目2
						item3: stand.item3,//项目需求品目3
					}
				}
				await ajax.post('/api/services/app/ClMeetingRoom/CreateOrUpdateExt', book_data).then((res) => {
					self.roomBookModal = false;
					self.formObj = JSON.parse(JSON.stringify(self.emptyObj));
					if (self.projectData.id != 0) {
						self.getExist(self.projectData)
					}
					self.$Message.info("预约成功")

					// 添加日程时间
					let attendeeList = []
					if (stand.compere !== '') {
						stand.compere.split(',').forEach(item => {
							attendeeList.push({
								userid: item
							})
						})
					}
					// 客户经理项目助理跟进人员
					if (this.infouserList.length) {
						attendeeList = attendeeList.concat(this.infouserList)
					}
					if (!attendeeList.length) {
						// 避免为空
						attendeeList.push({
							userid: self.$store.state.session.user.name
						})
					}
					const schedule = {
						extId: md5(res.data.result.id),
						organizer: self.$store.state.session.user.name, // 当前用户人员
						startDate: stand.start,
						endDate: stand.end,
						attendeeList, // 参与者 主持人 协助人员
						summary: stand.title,
						description: `${stand.content}`,
						location: `${stand.area}-${new_room}`
					}
					sendMessage('schedule', schedule)

					self.getData();
					if(this.argumentData.id!=0){
						this.getAgData(self.argumentData.id)
					}
					if(this.projectData.id!=0){
						this.getNpData(self.projectData.id)
					}
					// self.getNpData(self.projectData.id)
				})
			}
		},
		//预约会议室处理
		delete_book(obj, type = '') {
			if (type === 'project') {
				// 项目人员或跟进人员可修改
				let aid = this.projectData.aid ? this.projectData.aid : ''
				let merchandiser = this.projectData.merchandiser ? this.projectData.merchandiser : ''
				if (aid.indexOf(this.$store.state.session.user.name) === -1 && merchandiser.indexOf(this.$store.state.session.user.name) === -1 && this.roles.indexOf('分公司项目经理') === -1) {
					this.$Message.info('此项目项目助理或跟进人员或项目经理才可删除')
					return
				}
				// 一个月之内的可以修改
				let beginTime = obj.beginTime.split('T')[0]
				beginTime = new Date(beginTime).getTime()
				let thisTime = new Date().getTime()
				let monthTime = 30*24*60*60*1000
				if (beginTime < thisTime - monthTime) {
					this.$Message.info('预约时间已超过一个月，不可删除')
					return
				}
			}
			let pro_id = obj.id
			this.$Modal.confirm({
				title: "删除预约",
				content: "是否删除此预约",
				onOk: () => {
					ajax.delete('/api/services/app/ClMeetingRoom/Delete?id=' + pro_id).then((res) => {
						if (res.data.success) {
							this.roomBookModal = false;
							this.getData()
							if(this.argumentData.id!=0){
								this.getAgData(obj.clMeetingRoomExt.argumentId)
							}
							if(this.projectData.id!=0){
								this.getNpData(this.projectData.id)
							}
							this.$Message.info("删除成功");
							
							// 删除日程
							const scheduleId = obj.clMeetingRoomExtId ? md5(obj.clMeetingRoomExtId) : md5(pro_id)
							sendMessage('delSchedule', scheduleId)
						}
					})
				}
			});
		},
		async confirmProjectForm() {
			this.$Modal.confirm({
				title: '修改会议信息',
				content: '确定修改专家、采购人数量等信息？',
				onOk: async () => {
					try {
						this.$Spin.show()
						this.projectData.expertNum = this.projectForm.expertNum
						this.projectData.purchaserNum = this.projectForm.purchaserNum
						this.projectData.bidderNum = this.projectForm.bidderNum
						let rep = await ajax.post(requestUrls.ClProjectDb.CreateOrUpdate, {
							clProjectDb: this.projectData
						})
						this.$Spin.hide()
						if (rep.data.success) {
							this.$Message.success('提交成功')
						} else {
							this.$Message.error('提交失败')
						}
					} catch (err) {
						this.$Spin.hide()
						console.error(err)
						this.$Message.error('提交失败')
					}
				}
			})
		},
		// 获取数据字典
		async getDataDict(type = '',ip = 0,id) {//ip控制是否只查询一级数据
    	  if (!type) {
    	    return []
    	  }
    	  let para = {}
    	  if(ip){
    	    para = {
    	      filter: `itemType=="${type}"&&itemParent==""`
    	    }
    	  }else{
    	    para = {
    	      filter: `itemType=="${type}"`
    	    }
    	  }
    	  if(id){
    	    para = {
    	      filter: `itemType=="${type}"&&itemParent=="${id}"`
    	    }
    	  }
    	  let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
    	    params: para
    	  })
    	  if (rep.data.success) {
    	    return rep.data.result.items
    	  }
    	  return []
    },
		// 确认使用
		confirmUsed (item) {
			const clMeetingRoom = Object.assign(item, {
				isConfirm: 1,
				confirmDate: formatDate(),
				confirmPerson: this.$store.state.session.user.name
			})
			delete clMeetingRoom.clMeetingRoomExt
			delete clMeetingRoom.clProjectDb
			delete clMeetingRoom.rate
			ajax.post('/api/services/app/ClMeetingRoom/CreateOrUpdate', {
				clMeetingRoom
			}).then(res => {
				this.roomBookModal = false
				this.$Message.success('已确认')
				this.getData()
				this.getNpData(self.projectData.id)
			})
		}
	}
}
</script>
